import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Button from '../common/Button';

// 컴포넌트 스타일 정의
const AuthFormBlock = styled.div`
  h3 {
    margin: 0;
    color: var(--text-bright);
    margin-bottom: 1rem;
    font-size: 1.5rem;
  }
`;

const StyledInput = styled.input`
  font-size: 1rem;
  border: none;
  border-bottom: 1px solid var(--text-dark);
  padding-bottom: 0.5rem;
  outline: none;
  width: 100%;
  background: transparent;
  color: var(--text-normal);
  &:focus {
    color: var(--text-bright);
    border-bottom: 1px solid var(--primary-accent);
  }
  & + & {
    margin-top: 1rem;
  }
`;

const Footer = styled.div`
  margin-top: 2rem;
  text-align: right;
  a {
    color: var(--text-normal);
    text-decoration: underline;
    &:hover {
      color: var(--primary-accent);
    }
  }
`;

const ButtonWithMarginTop = styled(Button)`
  margin-top: 1rem;
`;


const textMap: { [key: string]: string } = {
    login: '로그인',
    register: '회원가입'
};

// AuthForm 컴포넌트가 받는 props들의 타입을 정의합니다.
interface AuthFormProps {
    type: 'login' | 'register';
    form: { [key: string]: string };
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

const AuthForm: React.FC<AuthFormProps> = ({ type, form, onChange, onSubmit }) => {
    const text = textMap[type];
    const isRegister = type === 'register';

    return (
        <AuthFormBlock>
            <h3>{text}</h3>
            <form onSubmit={onSubmit}>
                <StyledInput
                    autoComplete="username"
                    name="id"
                    placeholder="아이디"
                    onChange={onChange}
                    value={form.id || ''}
                    readOnly={isRegister} // 회원가입 시 읽기 전용
                    style={isRegister ? { background: '#f0f0f0', cursor: 'not-allowed' } : {}}
                />

                {/* 비밀번호 부분은 소셜 연동 상태임을 암시하도록 처리 */}
                <StyledInput
                    autoComplete="new-password"
                    name="password"
                    placeholder={isRegister ? "•••••••• (통합 계정 연동)" : "비밀번호"}
                    type="password"
                    onChange={onChange}
                    value={isRegister ? '********' : (form.password || '')}
                    readOnly={isRegister}
                />

                {isRegister && (
                    <>
                        <StyledInput
                            autoComplete="name"
                            name="name"
                            placeholder="사용자 이름(닉네임)"
                            onChange={onChange}
                            value={form.name || ''}
                        />
                        <p style={{ fontSize: '0.8rem', color: 'gray', marginTop: '0.5rem' }}>
                            ※ 통합 계정의 아이디와 비밀번호로 가입됩니다.
                        </p>
                    </>
                )}
                <ButtonWithMarginTop cyan fullWidth>{text}</ButtonWithMarginTop>
            </form>
            {!isRegister && (
                <Footer>
                    <Link to="/register">회원가입</Link>
                </Footer>
            )}
        </AuthFormBlock>
    );
};

export default AuthForm;

